export const getCurrentCompletedQuizTotal = (questions: any): number => {
  const totalAmount = questions.reduce((acc, { component, choices }) => {
    if (component === 'preferredgarmenttype') {
      return acc + 1
    }
    return acc + choices.length
  }, 0)

  return totalAmount
}

export const getCurrentCompletedQuestions = (
  questions: any,
  currentQuestionIndex: number,
  currentChoiceIndex: number,
): number => {
  let currentCompletedQuestions = 0
  let currentCompletedChoices = 0

  for (let i = 0; i < currentQuestionIndex; i += 1) {
    const { component, choices } = questions[i]
    if (component === 'preferredgarmenttype') {
      currentCompletedQuestions += 1
    } else {
      currentCompletedChoices += choices.length
    }
  }

  const totalCompletedParts =
    currentCompletedQuestions + currentCompletedChoices + currentChoiceIndex

  return totalCompletedParts
}
